export default {
  url: window.UNLEASH_HOST,
  clientKey: window.UNLEASH_KEY,
  refreshInterval: 15,
  appName: window.UNLEASH_APP_NAME,
};
